<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <b-card v-else>
            <h5 class="mb-0">
                <i class="fa fa-fw fa-users mr-2" />Daftar Pembeli
            </h5>
            <hr />
            <b-row>
                <b-col xs="12" sm="8" md="6" lg="5" xl="4">
                    <b-form-group label="Nama Pembeli">
                        <b-form-input
                            v-model="filter.name"
                            maxlength="50"
                            @keydown.enter="getUsers"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Aksi">
                        <b-button variant="primary" @click="getUsers()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table
                bordered
                hover
                show-empty
                no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                responsive
                class="mb-3"
                id="local-table"
                :current-page="currentPage"
                @sort-changed="onSortChanged"
            >
                <template v-slot:empty> Tidak ada data pembeli. </template>
                <template v-slot:cell(name)="row">
                    <span>{{ row.item.nama }}</span>
                </template>
                <template v-slot:cell(toko)="row">
                    <span>{{ row.item.nama_toko }}</span>
                </template>
                <template v-slot:cell(role_id)="row">
                    <b-badge variant="primary" v-if="row.item.role_id == 1"
                        >Akun Biasa</b-badge
                    >
                    <b-badge variant="warning" v-else-if="row.item.role_id == 2"
                        >Akun Pedagang</b-badge
                    >
                </template>
                <template v-slot:cell(is_active)="row">
                    <b-badge variant="success" v-if="row.item.is_active == 1"
                        >Aktif</b-badge
                    >
                    <b-badge variant="danger" v-else>Nonaktif</b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="d-flex">
                        <b-button
                            size="sm"
                            variant="warning"
                            v-b-tooltip.hover.top
                            title="Ubah Status Akun"
                            :disabled="isBusy || isSubmitting"
                            @click="changeStatus(row.item)"
                        >
                            <i class="fa fa-fw fa-pencil" />
                        </b-button>
                        <b-button
                            size="sm"
                            class="ml-2"
                            variant="secondary"
                            v-b-tooltip.hover.top
                            title="Detail"
                            @click="getDetail(row.item.id)"
                        >
                            <i class="fa fa-info-circle" />
                        </b-button>
                        <b-button
                            size="sm"
                            class="ml-2"
                            :variant="
                                row.item.is_active == 1 ? 'danger' : 'success'
                            "
                            v-b-tooltip.hover.top
                            :title="
                                row.item.is_active == 1
                                    ? 'Nonaktifkan'
                                    : 'Aktifkan'
                            "
                            :disabled="
                                (row.item.role_id == 1 &&
                                    row.item.is_active == 1) ||
                                isBusy ||
                                isSubmitting
                            "
                            @click="confirmToggle(row.item)"
                        >
                            <i class="fa fa-fw fa-power-off" />
                        </b-button>
                    </div>
                </template>
            </b-table>
            <PageSizer
                :totalRows="pageLength"
                :page="currentPage"
                :options="options"
                @limit-change="onLimitChange"
                @page-change="onPageChange"
            />
        </b-card>
        <b-modal
            id="m-detail"
            size="lg"
            title="Detail Data Pembeli"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <b-container>
                <div class="info-container">
                    <div>
                        <b-row class="mt-3">
                            <b-col cols="12">
                                <div class="img-container">
                                    <b-img-lazy
                                        class="img-item"
                                        :src="detail.image"
                                        alt="Gambar Pembeli"
                                    />
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                    <div>
                        <b-row class="mt-3">
                            <b-col cols="4">ID</b-col>

                            <b-col cols="7">
                                <p>{{ detail.id }}</p></b-col
                            >
                            <b-col cols="4">Nama</b-col>

                            <b-col cols="7">
                                <p>{{ detail.nama }}</p></b-col
                            >
                            <b-col cols="4">Nama Toko</b-col>

                            <b-col cols="7">
                                <p>{{ detail.nama_toko }}</p></b-col
                            >
                            <b-col cols="4">Email</b-col>

                            <b-col cols="7">
                                <p>{{ detail.email }}</p></b-col
                            >
                            <b-col cols="4">No HP</b-col>

                            <b-col cols="7"
                                ><p>{{ detail.nohp }}</p></b-col
                            >

                            <b-col cols="4">Alamat</b-col>

                            <b-col cols="7"
                                ><p>{{ detail.alamat }}</p></b-col
                            >

                            <b-col cols="4">Terakhir Aktif</b-col>

                            <b-col cols="7" class="mb-3">
                                <table>
                                    <tr>
                                        <td>Tanggal</td>
                                        <td>:</td>
                                        <td>
                                            {{
                                                "&nbsp;" +
                                                formatDate(
                                                    detail.last_active.split(
                                                        " "
                                                    )[0]
                                                )
                                            }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Jam</td>
                                        <td>:</td>
                                        <td>
                                            {{
                                                "&nbsp;" +
                                                detail.last_active.split(" ")[1]
                                            }}
                                        </td>
                                    </tr>
                                </table>
                            </b-col>
                            <b-col cols="4" class="mb-3">Status Akun</b-col>

                            <b-col cols="7"
                                ><b-badge
                                    variant="primary"
                                    v-if="detail.role_id == 1"
                                    >Akun Biasa</b-badge
                                >
                                <b-badge
                                    variant="warning"
                                    v-else-if="detail.role_id == 2"
                                    >Akun Pedagang</b-badge
                                ></b-col
                            >
                            <b-col cols="4">Status Aktif</b-col>

                            <b-col cols="7"
                                ><b-badge
                                    variant="success"
                                    v-if="detail.is_active == 1"
                                    >Aktif</b-badge
                                >
                                <b-badge
                                    variant="danger"
                                    v-else-if="detail.is_active == 0"
                                    >Nonaktif</b-badge
                                ></b-col
                            >
                        </b-row>
                    </div>
                </div>
            </b-container>

            <div class="mt-4 text-right">
                <b-button variant="primary" @click="close()">
                    Kembali
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
// import moment from "moment";

export default {
    data() {
        return {
            initStatus: 0,
            isFilter: false,
            isBusy: true,
            isSubmitting: false,

            filter: {
                name: "",
            },

            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" },
            ],

            fields: [
                { key: "name", label: "Nama Pembeli", sortable: true },
                { key: "toko", label: "Nama Toko", sortable: true },
                { key: "role_id", label: "Status Akun", sortable: true },
                { key: "is_active", label: "Status Aktif", sortable: true },
                { key: "action", label: "Aksi", sortable: false },
            ],

            detail: {
                id: 0,
                nama: "",
                nama_toko: "",
                email: "",
                nohp: "",
                alamat: "",

                image: "",
                last_active: "",
                role_id: 0,
                is_active: 0,
            },

            items: [],
            filteredItems: [],

            currentPage: 1,
            pageLength: 0,
            perPage: 10,

            totalRows: 0,
            sortBy: null,
            sortDesc: false,
        };
    },

    methods: {
        formatDate(dateString) {
            const options = { day: "numeric", month: "long", year: "numeric" };
            const date = new Date(dateString);
            return date.toLocaleDateString("id-ID", options);
        },
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        close() {
            this.$bvModal.hide("m-detail");
        },
        init() {
            this.initStatus = 0;
            let getUsers = this.getUsers();

            Promise.all([getUsers])
                .then(() => {
                    this.initStatus = 1;
                })
                .catch((_) => {
                    this.initStatus = -1;
                });
        },

        getDetail(id) {
            this.isBusy = true;
            return this.$axios
                .post(`admin/getDetailEcomUsers?id=${id}`)
                .then((res) => {
                    const data = res.data.data;

                    this.detail = data;

                    this.detail = {
                        ...data,
                        last_active: data.last_active ? data.last_active : "",
                        image: this.$BASE_FILE_PATH + data.image,
                    };

                    this.$bvModal.show("m-detail");
                })
                .catch((error) => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        getUsers(page = 1) {
            this.isBusy = true;
            this.items = [];

            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            // URL builder
            // let param = this.$helper.getBasePagedQuery(
            //     this.currentPage,
            //     this.perPage
            // );

            const payload = {
                page: this.currentPage,
                perPage: this.perPage,
                name: this.filter.name || "",
                sortBy:
                    this.sortBy === "name"
                        ? "nama"
                        : this.sortBy === "toko"
                        ? "nama_toko"
                        : this.sortBy || "id",
                sortDesc: this.sortDesc,
            };

            return this.$axios
                .post(`admin/ecomUsers`, payload)
                .then((res) => {
                    const data = res.data.data;
                    this.pageLength = data.total;
                    this.items = data.items;
                    this.filteredItems = data.items;
                })
                .catch((error) => {
                    // this.pageLength = 1;
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        confirmToggle(item) {
            let action = item.is_active == 1 ? "nonaktif" : "aktif";

            let isConfirmed = confirm(
                "Apakah anda yakin ingin meng" +
                    action +
                    'kan Pembeli "' +
                    item.nama +
                    '"?'
            );
            if (!isConfirmed) return;

            this.isSubmitting = true;

            let payload = {
                id: item.id,
                updateRole: false,
                updateStatus: true,
            };

            this.$axios
                .post("admin/updateEcomUsers", payload)
                .then((_) => {
                    this.$helper.toastSuccess(
                        this,
                        "Pembeli berhasil di" + action + "kan!"
                    );
                    this.getUsers(this.currentPage);
                })
                .catch((error) => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        changeStatus(item) {
            let action = item.role_id == 1 ? "pedagang" : "biasa";

            let isConfirmed = confirm(
                "Apakah anda yakin ingin mengubah user '" +
                    item.nama +
                    "' menjadi akun " +
                    action +
                    "?"
            );
            if (!isConfirmed) return;

            this.isSubmitting = true;

            let payload = {
                id: item.id,
                updateRole: true,
                updateStatus: false,
            };

            this.$axios
                .post("admin/updateEcomUsers", payload)
                .then((_) => {
                    this.$helper.toastSuccess(
                        this,
                        "Status Akun User berhasil diubah!"
                    );
                    this.getUsers(this.currentPage);
                })
                .catch((error) => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getUsers(this.currentPage);
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getUsers(this.currentPage);
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getUsers();
        },

        onFilterChanged(items) {
            this.isFilter = true;
            this.filteredItems = items;
        },
    },

    created() {
        this.init();
    },
};
</script>

<style scoped>
.info-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
}

.img-container {
    height: 320px;
    width: 320px;
    background: #eee;
}

.img-item {
    object-fit: cover;
    object-position: center;
    width: 100%;
    height: 100%;
}

@media (max-width: 990px) {
    .info-container {
        grid-template-columns: 1fr 1fr;
        grid-gap: 10px;
    }
}

@media (max-width: 600px) {
    .info-container {
        grid-template-columns: 1fr;
    }
}
</style>
